import { useState } from 'react';
import { useSearch } from '../useSearch';
import bankAccount from '../../constants/bankAccount.json';

interface BankAccount {
  value: string;
  label: string;
}

type BankAccountSearchResult = BankAccount[];

const searchBankAccounts = (jsonData: BankAccount[], searchText: string): BankAccountSearchResult => {
  const filteredBanks = jsonData.filter((bank) =>
    bank.label.toLowerCase().includes(searchText.toLowerCase())
  );
  return filteredBanks;
};

export const useBankAccountSearch = () => {
  const [isSearching, setIsSearching] = useState(false);

  const { data: bankAccounts, handleSearch } = useSearch<BankAccount, BankAccountSearchResult>({
    service: null, 
    endpoint: '', 
    queryParameter: '',
    responseMapper: () => [],
    searchFunction: (searchText: string) => {
      setIsSearching(true);
      const result = searchBankAccounts(bankAccount, searchText);
      setIsSearching(false);
      return result;
    },
  });

  return { bankAccount, isSearching, handleSearch };
};
